'use strict';

import { CSS2DObject } from "../../../libs/CSS2DRenderer.js";
import { threeJsVariables, isMobile, Buildings, projectMode, TRoot, settingsData } from '../../../settings';
import { Box3, MathUtils, Raycaster, Vector3 } from 'three';
import { getCurrentCameraDistance } from '../../controls/orbitControls';
import { Vector2 } from 'three';
import { setCoordinates } from '../../threejs/autoProjectScript';
import { addPoiToIntersection } from '../../poi/poiCss';
import { Group } from 'three';
import { ViewMode } from '../../../common';
import { enterToTheBuildingWithMaxAvailableApartments } from './building_switch';
import { Cluster } from '../../threejs/Cluster/CSS2DCluster';
import { Cloudflare } from '../../api/Cloudflare';
import { BaseElement } from '../../interfaces/BaseElement';
import { createAnimatedProjectLabel } from '../../widgets/poi/poiv3';
import { BmbyMode } from '../../mode/BmbyMode';
import { getCSSVarValue, setCSSVar } from "../../../functions.js";

const buildingLabels = [];
const zoomRule = config.threejs.label.size || 0.6;

export function BuildingLabels(selectionBoxes) {
	if (projectMode.LiteMode.isActive()) {
		buildingLabelLiteMode();
		return;
	}

	if (config.features.blockCylinderMode || BmbyMode.active || projectMode.AirMode.active) {
		return;
	}

	if (config.features.privateHouseMode) {
		oneLabelLogic(selectionBoxes, 'privateHouse');
		return;
	}

	if (config.threejs.label.oneLabel) {
		oneLabelLogic(selectionBoxes, 'oneLabel');
		return;
	}

	const scene = threeJsVariables.scene;
	const buildingsLabelsGroup = new Group();
	const { y } = config.threejs.projectRotation;
	const { heightCorrection, resize } = config.threejs.label;
	buildingsLabelsGroup.name = 'buildingsLabelsGroup';
	if (!threeJsVariables.bundleConfig) {
		buildingsLabelsGroup.rotation.set(0, y, 0);
	} else if (threeJsVariables.bundleConfig && threeJsVariables.bundleConfig.version) {
		setCoordinates(buildingsLabelsGroup, threeJsVariables.bundleConfig.project);
	} else {
		setCoordinates(buildingsLabelsGroup, threeJsVariables.bundleConfig.building);
	}
	//buildingsLabelsGroup.rotation.set(0,y,0);
	//For Cnaan env
	// const selectionBoxesParent = selectionBoxes[0].parent;
	// buildingsLabelsGroup.position.set(selectionBoxesParent.position.x,selectionBoxesParent.position.y,selectionBoxesParent.position.z);
	// buildingsLabelsGroup.rotation.set(selectionBoxesParent.rotation.x,selectionBoxesParent.rotation.y,selectionBoxesParent.rotation.z);
	// buildingsLabelsGroup.scale.set(selectionBoxesParent.scale.x,1,selectionBoxesParent.scale.z);

	// buildings_info.forEach(building => {
	//     const buildingMesh = selectionBoxes.filter(sb => sb.name === `${building.name}_selectionBoxes`)[0];
	//     const sBoxSize = new Box3().setFromObject(buildingMesh).getSize(new THREE.Vector3());
	//     const labelContainer = document.createElement('div');
	//     const labelTowerNumber = building.labelName;
	//     // const labelTowerLetter = building.labelName.charAt(building.labelName.length - 1);
	//     labelContainer.className = 'building-labels';
	//
	//     labelContainer.setAttribute('data-attribute', building.labelName);
	//
	//     if (building.buildingIcon.length){
	//         labelContainer.innerHTML = `
	//     <div class='building-labels_wrapper' data-name="${building.name}" data-label="labelTower-${building.labelName}">
	//         <div class="building-labels__icon" style="background: url(${building.buildingIcon})"></div>
	//     </div>
	//     `;
	//
	//     } else {
	//
	//         labelContainer.innerHTML = `
	//     <div class='building-labels_wrapper' data-name="${building.name}" data-label="labelTower-${building.labelName}">
	//         <span>${labelTowerNumber}</span>
	//     </div>
	//     `;
	//     }
	//
	//     if (labelContainer) {
	//         if (labelContainer.getAttribute('data-attribute') === building.labelName) {
	//             labelContainer.classList.add('active');
	//         }
	//     }
	//     const label = new CSS2DObject(labelContainer);
	//     // const diffHightLabels = (window.innerWidth < 450) ? 20 : 15;
	//     // const diffHightLabels = (window.innerWidth < 450) ? 50 : 30; /// Remove when building position is 0,0,0
	//     const diffHightLabels = isMobile ? heightCorrection.mobile : heightCorrection.desktop;
	//
	//     label.name = `labelTower-${building.labelName}`;
	//     //label.material = new THREE.MeshBasicMaterial({color: 'red'});
	//
	//     // label.position.set(roofCenterPoint.x, roofCenterPoint.y + diffHightLabels, roofCenterPoint.z);
	//     label.position.set(buildingMesh.position.x, sBoxSize.y + diffHightLabels + buildingMesh.position.y, buildingMesh.position.z);
	//
	//     if (resize){
	//         const currentCameraDistance = getCurrentCameraDistance();
	//         label.userData.zoom = 1 / currentCameraDistance * 100 + 0.25;
	//     } else {
	//         label.userData.zoom = 1;
	//     }
	//
	//     // label.userData.zoom = isMobile ? 0.9 : 1;
	//
	//     buildingsLabelsGroup.add(label);
	//
	// });
	const CLUSTERS = {};
	const buildings = Buildings.getBuildingsArray();

	if (Cluster.active) {
		const lots = [...new Set(buildings.map(building => building.info.buildingLot).filter(lot => lot?.length))];
		lots.forEach(id => {
			CLUSTERS[id] = new Cluster(id);
		});
	}

	buildings.forEach((building, index) => {
		const buildingMesh = selectionBoxes.filter(sb => sb.name === `${building.name}_selectionBoxes`)[0];

		if (!buildingMesh)
			return;
		
		const label = createBuildingCSSLabel(building);
		label.name = `labelTower-${building.info.labelName}`;
		
		if (threeJsVariables?.bundleConfig?.buildingLabels && threeJsVariables?.bundleConfig?.buildingLabels?.[building.name]) {
			const labelConfig = threeJsVariables.bundleConfig.buildingLabels[building.name];
			label.position.fromArray(labelConfig.position);
			label.center.fromArray(labelConfig.pivot);
			label.userData.zoom = labelConfig.zoom;
		} else {
			const sBoxSize = new Box3().setFromObject(buildingMesh).getSize(new Vector3());
			const diffHightLabels = heightCorrection.desktop;
			label.position.set(buildingMesh.position.x, sBoxSize.y + diffHightLabels + buildingMesh.position.y, buildingMesh.position.z);
			
			if (resize) {
				const currentCameraDistance = getCurrentCameraDistance();
				label.userData.zoom = 1 / currentCameraDistance * 100 + 0.25;
			} else {
				label.userData.zoom = zoomRule;
			}
		}

		// label.userData.zoom = isMobile ? 0.9 : 1;

		const cluster = CLUSTERS[building.info.buildingLot];

		if (cluster) {
			if (!cluster.parent) {
				buildingsLabelsGroup.add(cluster);
				addPoiToIntersection(cluster);
			}

			cluster.add(label);
			cluster.updateCount();

		} else {
			buildingsLabelsGroup.add(label);
			addPoiToIntersection(label);
		}

		buildingLabels.push(label);

	});

	buildingsLabelHideWhenAnimationStart();

	scene.add(buildingsLabelsGroup);

	Object.values(CLUSTERS).forEach(cluster => cluster.split());
	if (Cluster.buildingLabelMode) {
		Object.values(CLUSTERS).forEach(cluster => {
			if (resize) {
				const currentCameraDistance = getCurrentCameraDistance();
				cluster.userData.zoom = 1 / currentCameraDistance * 100 + 0.25;
			} else {
				cluster.userData.zoom = zoomRule;
			}

			buildingLabels.push(cluster);
		});
	}
}

export function createBuildingCSSLabel(building) {
	const colors = config.threejs.label.colors || {};
	const hideClickHere = config.threejs.label.hideClickHere;
	const newStyle = config.threejs.label.newStyle;

	const labelContainer = document.createElement('div');
	const labelTowerNumber = threeJsVariables.orbitBuildingsNavigation.active ? threeJsVariables.orbitBuildingsNavigation.getBuildingLabelName(building) : building.info.labelName;
	const buildingColor = building.info.color;

	labelContainer.className = 'building-labels';
	labelContainer.setAttribute('data-attribute', building.info.labelName);
	
	if (threeJsVariables.orbitBuildingsNavigation.active) {
		labelContainer.addEventListener('click', () => threeJsVariables.orbitBuildingsNavigation.clickHandler(building,'buildingPoi'));
	} else {
		labelContainer.addEventListener('click', labelContainerClickHandler);
	}
	
	if (newStyle) {
		labelContainer.classList.add('building-label--new-style');
		labelContainer.innerHTML = `
            <div class='building-labels_wrapper'
             data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
                <span class="building-labels__tower-name">${labelTowerNumber}</span>
                <span class="building-labels__available-apt">${building.info.availableApartments}</span>
            </div>`;
	} else {
		const labelBGColor = Boolean(buildingColor)
			? buildingColor
			: undefined;
		
		if (building.info.buildingIcon.length) {
			labelContainer.innerHTML = `
			<div class='building-labels_wrapper ${hideClickHere ? 'hide-click-here' : 'show-click-here'}' data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
				<div class="building-label-bubble">${getBuildingLabel(labelBGColor)}</div>
				<div class="building-labels__icon" style="background: url(${building.info.buildingIcon})"></div>
			</div>
        `;
			
		} else {
			labelContainer.innerHTML = `
            <div class='building-labels_wrapper ${hideClickHere ? 'hide-click-here' : 'show-click-here'}'
             data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
                <div class="building-label-bubble">${getBuildingLabel(labelBGColor)}</div>
                <span>${labelTowerNumber}</span>
        </div>`;
		}
		
		if (colors.text) {
			labelContainer.querySelector('.building-labels_wrapper').style = `color: ${colors.text}`;
		} else {
			setClickHereContrastColor(labelBGColor);
		}
	}
	
	if (labelContainer.getAttribute('data-attribute') === building.info.labelName) {
		labelContainer.classList.add('active');
	}
	
	const label = new CSS2DObject(labelContainer);
	label.name = `labelTower-${building.info.labelName}`;
	if (config.threejs.label?.bottomPivot)
		label.center.y = 1;
	return label;
}

function setClickHereContrastColor(labelBGColor) {
	if (!labelBGColor)
		labelBGColor = '#ffffff';
	
	// Convert hex color to RGB
	const hexToRgb = (hex) => {
		// Remove # if present
		hex = hex.replace('#', '');

		// Parse the hex values
		const r = parseInt(hex.substring(0, 2), 16);
		const g = parseInt(hex.substring(2, 4), 16);
		const b = parseInt(hex.substring(4, 6), 16);

		return [r, g, b];
	}

	// Extract RGB values from various color formats
	const rgbaToRgb = (color) => {
		// If it's already an array, return it
		if (Array.isArray(color)) {
			return color;
		}

		// Handle rgba/rgb string format
		if (typeof color === 'string') {
			// Check for rgb/rgba format
			const rgbMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/);
			if (rgbMatch) {
				return [parseInt(rgbMatch[1]), parseInt(rgbMatch[2]), parseInt(rgbMatch[3])];
			}

			// Check for hex format (in case this gets called with hex)
			if (color.startsWith('#')) {
				return hexToRgb(color);
			}
		}

		// Default fallback
		return [0, 0, 0];
	}

	const calculateLuminance = (rgb) => {
		const [r, g, b] = rgb.map(c => {
			c = c / 255;
			return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
		});
		return 0.2126 * r + 0.7152 * g + 0.0722 * b;
	}

	// Calculate luminance of background color and default text color
	const bgRgb = labelBGColor.startsWith('#') ?
		hexToRgb(labelBGColor) :
		rgbaToRgb(labelBGColor);
	let defaultTextColor = getCSSVarValue('--menuBg');
	const textColorRgb = defaultTextColor.startsWith('#') ?
		hexToRgb(defaultTextColor) :
		rgbaToRgb(defaultTextColor);

	const bgLuminance = calculateLuminance(bgRgb);
	const textLuminance = calculateLuminance(textColorRgb);

	// If background and default text color is dark (luminance < 0.5), use white text
	// if background is dark and default text color is light (luminance > 0.5), use black text
	// Otherwise use default text color
	const isBgDark = bgLuminance < 0.4;
	const isDefaultTextDark = textLuminance < 0.4;
	if (isBgDark && isDefaultTextDark) {
		defaultTextColor = '#ffffff';
	} else if (!isBgDark && !isDefaultTextDark) {
		defaultTextColor = '#000000';
	}

	setCSSVar('--building-label-click-here-color', defaultTextColor);
}

export const labelContainerClickHandler = async (e) => {
	if (!e.target.closest('.building-labels_wrapper'))
		return;

	const wrapper = e.target.closest('.building-labels_wrapper');
	const clickedLabelBuildingName = wrapper.getAttribute('data-name');
	const clickedBuilding = Buildings.getBuilding(clickedLabelBuildingName)
	await projectMode.Cylinder.enter(clickedBuilding);
};

export function buildingLabelLiteMode() {
	if (projectMode.LiteMode.modeIs('picture') || projectMode.LiteMode.modeIs('empty')) {
		createEmptyBuildingLabels();
		return;
	} else if (projectMode.LiteMode.modeIs('rotate')) {
		projectMode.LiteMode.rotor.initLabels();
		return;
	}

	const buildings = Buildings.getBuildingsArray();
	const colors = config.threejs.label.colors || {};
	const hideClickHere = config.threejs.label.hideClickHere;

	buildings.forEach(building => {
		const selection = projectMode.LiteMode.intersections.find(sb => sb.name.startsWith(building.name));

		if (!selection || !Object.keys(building.info).length) return;

		const labelTowerNumber = building.info.labelName;
		const labelContainer = document.createElement('div');
		labelContainer.className = 'building-labels';
		labelContainer.setAttribute('data-attribute', labelTowerNumber);
		const buildingColor = building.info.color;
		const labelBGColor = Boolean(buildingColor)
			? buildingColor
			: undefined;

		if (building.info.buildingIcon.length) {
			labelContainer.innerHTML = `
        <div class='building-labels_wrapper ${hideClickHere ? 'hide-click-here' : 'show-click-here'}' data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
            <div class="building-label-bubble">${getBuildingLabel(labelBGColor)}</div>
            <div class="building-labels__icon" style="background: url(${building.info.buildingIcon})"></div>
        </div>
        `;

		} else {

			labelContainer.innerHTML = `
            <div class='building-labels_wrapper ${hideClickHere ? 'hide-click-here' : 'show-click-here'}' data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
                <div class="building-label-bubble">${getBuildingLabel(labelBGColor)}</div>
                <span>${labelTowerNumber}</span>
            </div>
            `;
		}

		if (colors.text) {
			labelContainer.querySelector('.building-labels_wrapper').style = `color: ${colors.text}`;
		} else if (labelBGColor) {
			setClickHereContrastColor(labelBGColor);
		}

		labelContainer.classList.add('active');
		const label = new CSS2DObject(labelContainer);
		label.name = `labelTower-${building.info.labelName}`;
		labelContainer.addEventListener('click', labelContainerClickHandler);

		if (config.features.liteMode.settings.buildingLabelDiff) {
			label.userData.zoom = 1 - config.features.liteMode.settings.buildingLabelDiff;
		} else {
			label.userData.zoom = zoomRule;
		}

		selection.add(label);
	});
}

function oneLabelLogic(selections, name) {
	const box = new Box3();
	selections.forEach(selection => box.expandByObject(selection));
	const size = new Vector3();
	const center = new Vector3();
	box.getSize(size);
	box.getCenter(center);

	const buildingsLabelsGroup = new Group();
	const { heightCorrection, resize } = config.threejs.label;
	const hideClickHere = config.threejs.label.hideClickHere;
	buildingsLabelsGroup.name = 'buildingsLabelsGroup';
	// const colorBg = config.style.colors.find(color => color.key === 'brand1');

	createAnimatedProjectLabel(!isMobile)
		.then(svg => {

			const labelContainer = new BaseElement()
				.addClass('building-labels', 'active', 'all-in-one__label')
				.event('click', () => enterToTheBuildingWithMaxAvailableApartments())
				.DOMElement;

			labelContainer.innerHTML = `
			    <div class='building-labels_wrapper all-in-one__label-wrapper ${config.features.privateHouseMode ? 'building-labels__private-house' : ''} ${hideClickHere ? 'hide-click-here'
					: 'show-click-here'}' data-name="${name}" data-label="labelTower-all-in-one">
			        <div class="building-label-bubble">${svg}</div>
			        <div class="building-labels__icon" style="background: url(${Cloudflare.resize(config.general.logo, { width: 200 })})"></div>
			    </div>
			    `;

			const height = size.y + center.y + heightCorrection.desktop;
			const label = new CSS2DObject(labelContainer);
			label.name = `labelTower-all-in-one`;
			label.position.set(center.x, height, center.z);
			if (resize) {
				const currentCameraDistance = getCurrentCameraDistance();
				label.userData.zoom = 1 / currentCameraDistance * 100 + 0.25;
			} else {
				label.userData.zoom = zoomRule;
			}
			addPoiToIntersection(label);
			buildingsLabelsGroup.add(label);
		});

	// const labelContainer = new BaseElement()
	// 	.addClass('building-labels','active','private-house__label')
	// 	.event('click',() => enterToTheBuildingWithMaxAvailableApartments())
	// 	.DOMElement;
	//
	// labelContainer.innerHTML = `
	//     <div class='building-labels_wrapper ${hideClickHere ? 'hide-click-here' : 'show-click-here'}' data-name="privateHouse" data-label="labelTower-privateHouse">
	//         <div class="building-label-bubble">${getBuildingLabel(`rgba(${colorBg.value})`)}</div>
	//         <div class="building-labels__icon" style="background: url(${Cloudflare.resize(config.general.logo, {width: 200})})"></div>
	//     </div>
	//     `;
	// const height = size.y + center.y + heightCorrection.desktop;
	// const label = new CSS2DObject(labelContainer);
	// label.name = `labelTower-privateHouse`;
	// label.position.set(center.x, height, center.z);
	// label.userData.zoom = 1;
	// buildingsLabelsGroup.add(label);
	createBuildingsApartmentsCountLabel(selections,buildingsLabelsGroup);
	threeJsVariables.scene.add(buildingsLabelsGroup);
}

function createBuildingsApartmentsCountLabel (selectionBoxes,group) {
	if (!config.threejs.label.apartmentsCount)
		return;
	
	const buildings = Buildings.getBuildingsArray();
	
	buildings.forEach(building => {
		const buildingMesh = selectionBoxes.filter(sb => sb.name === `${building.name}_selectionBoxes`)[0];
		
		if (!buildingMesh)
			return;
		
		const sBoxSize = new Box3().setFromObject(buildingMesh).getSize(new Vector3());
		const position = new Vector3();
		buildingMesh.getWorldPosition(position);
		const labelContainer = document.createElement('div');
		
		labelContainer.className = 'building-label__apartments-count';
		labelContainer.setAttribute('data-attribute', building.info.labelName);
		// labelContainer.addEventListener('click', labelContainerClickHandler);
		
		labelContainer.innerHTML = `
            <div class='building-label__apartments-count__wrapper'
             data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
               <div class="building-label__apartments-count__value">${building.info.availableApartments}</div>
            </div>`;
		
		
		const label = new CSS2DObject(labelContainer);
		label.userData.zoom = 1;
		label.name = `labelTower-${building.info.labelName}_apartments-count`;
		const diffHightLabels = config.threejs.label.apartmentsCount.heightCorrection;
		label.position.set(position.x, sBoxSize.y + diffHightLabels + Math.abs(position.y), position.z);
		group.add(label);
	});
}


function createEmptyBuildingLabels() {
	const labels = config.features.liteMode.labels;
	if (!labels) return;

	const buildings = Buildings.getBuildingsArray();
	const colors = config.threejs.label.colors || {};
	const hideClickHere = config.threejs.label.hideClickHere;
	const group = projectMode.LiteMode.group;
	const isDebug = projectMode.LiteMode.debug;
	const labelsGroup = new Group();
	labelsGroup.name = 'Labels';
	group.add(labelsGroup);

	buildings.forEach(building => {
		const labelData = labels.find(obj => obj.buildingEngineId === building.name);

		if (!labelData) return;

		const labelContainer = document.createElement('div');
		const labelTowerNumber = building.info.labelName;
		labelContainer.className = 'building-labels';
		labelContainer.setAttribute('data-attribute', building.info.labelName);

		if (building.info.buildingIcon.length) {
			labelContainer.innerHTML = `
        <div class='lite-mode__building-label building-labels_wrapper ${hideClickHere ? 'hide-click-here' : 'show-click-here'}' data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
            <div class="building-label-bubble">${getBuildingLabel(colors.background)}</div>
            <div class="building-labels__icon" style="background: url(${building.info.buildingIcon})"></div>
        </div>
        `;

		} else {

			labelContainer.innerHTML = `
            <div class='lite-mode__building-label building-labels_wrapper ${hideClickHere ? 'hide-click-here' : 'show-click-here'}' data-name="${building.name}" data-label="labelTower-${building.info.labelName}">
                <div class="building-label-bubble">${getBuildingLabel(colors.background)}</div>
                <span>${labelTowerNumber}</span>
            </div>
            `;
		}

		const labelWrapper = labelContainer.querySelector('.building-labels_wrapper');

		if (colors.text) {
			labelWrapper.style = `color: ${colors.text}`;
		} else if (colors.background) {
			setClickHereContrastColor(colors.background);
		}

		labelContainer.classList.add('active');
		const label = new CSS2DObject(labelContainer);
		label.name = `labelTower-${building.info.labelName}`;
		label.userData.buildingEngineId = labelData.buildingEngineId;
		labelContainer.addEventListener('click', () => {
			if (settingsData.activeViewMode === ViewMode.Orbit) {
				enterToTheBuildingWithMaxAvailableApartments();
			}
		});

		labelContainer.addEventListener('pointerenter', () => {
			if (settingsData.activeViewMode === ViewMode.Orbit) {
				labelWrapper.classList.add('building__hovered');
			}
		});

		labelContainer.addEventListener('pointerleave', () => {
			labelWrapper.classList.remove('building__hovered');
		});


		if (config.features.liteMode.settings.buildingLabelDiff) {
			label.userData.zoom = 1 - config.features.liteMode.settings.buildingLabelDiff;
		} else {
			label.userData.zoom = zoomRule;
		}

		label.position.set(labelData.position.x, labelData.position.y, 0);
		labelsGroup.add(label);
	});

	isDebug && liteModeDebugLabels();
}


function liteModeDebugLabels() {
	const debugFolder = projectMode.LiteMode.debugFolder;
	const group = projectMode.LiteMode.group;
	const labels = group.getObjectByName('Labels');
	const labelsFolder = debugFolder.addFolder('Labels');
	const data = {};
	const fn = {
		update: (label) => {
			const id = label.userData.buildingEngineId;
			data[id] = {
				buildingEngineId: id,
				position: {
					x: label.position.x,
					y: label.position.y
				}
			}
		},
		export: () => {
			const configData = [];
			Object.values(data).forEach(value => configData.push(value));
			prompt('config.features.liteMode.labels : ', JSON.stringify(configData));
		}
	};

	labels.traverse(el => {
		if (!el.isGroup) {
			const id = el.userData.buildingEngineId;
			const labelFolder = labelsFolder.addFolder(id);
			labelFolder.add(el.position, 'x', -1, 1, 0.0001).onChange(() => fn.update(el));
			labelFolder.add(el.position, 'y', -1, 1, 0.0001).onChange(() => fn.update(el));
		}
	});

	labelsFolder.add(fn, 'export');
}

// export function buildingsLabelsToggle (buildingIndex) {
//     const labelGroup = threeJsVariables.scene.getObjectByName('buildingsLabelsGroup');
//     const activeBuilding = buildings_info[buildingIndex];
//     const labelPrefix = "labelTower-";
//
//     labelGroup.traverse(label =>{
//         if (buildingIndex !== undefined){
//             if (label.name !== labelPrefix + activeBuilding.labelName){
//                 label.visible = false;
//             } else {
//                 label.visible = true;
//             }
//         } else {
//             label.visible = true;
//         }
//     });
//
// }

export function buildingsLabelResize() {
	if (!threeJsVariables.orbitControls.enabled || !config.threejs.label.resize || !threeJsVariables.labelRenderer) {
		return;
	}

	const labelGroup = threeJsVariables.scene.getObjectByName('buildingsLabelsGroup');
	if (labelGroup) {
		const currentCameraDistance = getCurrentCameraDistance();
		// const {currentMinDistance,currentMaxDistance} = getOrbitControlsDistanceAndAngle();
		labelGroup.traverse(label => {
			if (label.type === 'Object3D' && !label.isCSS2DCluster) {
				// if (currentCameraDistance < currentMinDistance + 5){
				label.userData.zoom = 1 / currentCameraDistance * 100 + 0.25;
				//
				//     label.userData.zoom = isMobile ? 0.85 : 0.9;
				// } else {
				//     const calcZoom = 1 / currentCameraDistance * 100 + 0.25;
				//     if (isMobile){
				//         label.userData.zoom = calcZoom >= 0.85 ? 0.85 : calcZoom;
				//     } else {
				//         label.userData.zoom = calcZoom >= 0.9 ? 0.9 : calcZoom;
				//     }
				// }
			}
		});
		const canvas = threeJsVariables.renderer.getSize(new Vector2());
		const isLabelRenderExists = JSON.stringify(threeJsVariables.labelRenderer) !== '{}'
		if (isLabelRenderExists)
			threeJsVariables.labelRenderer.setSize(canvas.x, canvas.y);
		// threeJsVariables.labelRenderer.render(threeJsVariables.scene,threeJsVariables.perspectiveCamera);
	}
}

// export function buildingsLabelUpdate () {
//     const mainLabelContainer = threeJsVariables.labelRenderer.domElement;
//     if (mainLabelContainer){
//         mainLabelContainer.style.display = 'none';
//         setTimeout(()=>{
//             mainLabelContainer.style.display = 'block';
//         },10);
//     }
// }

// export function buildingsLabelUpdate () {
//
//     if (settingsData.activeViewMode !== ViewMode.Orbit){
//         return;
//     }
//
//     const buildingLabels = document.querySelectorAll('.building-labels_wrapper');
//
//     if (buildingLabels.length) {
//         buildingLabels.forEach(label =>{
//             label.style.display = '';
//         });
//         // if (settingsData.activeViewMode !== ViewMode.Cylinder) {
//         //     buildingLabels.style.display = 'none';
//         //     setTimeout(() => {
//         //         buildingLabels.removeAttribute('style')
//         //         // showPoi();
//         //     },10);
//         // } else {
//         //     buildingLabels.style.display = 'none';
//         // }
//     }
// }

export function hideBuildingLabels() {
	if (threeJsVariables.cssLabelManager.isBlocked('buildingLabels'))
		return;
	const buildingLabels = TRoot.querySelectorAll('.building-labels_wrapper:not(.lite-mode__building-label)');
	const buildingApartmentsCount = TRoot.querySelectorAll('.building-label__apartments-count');
	const labels = [...buildingLabels,...buildingApartmentsCount];

	if (labels.length) {
		labels.forEach(label => {
			label.classList.add('hidden');
		});
	}

	Cluster.hide();
}

export function showBuildingLabels() {
	if (threeJsVariables.cssLabelManager.isBlocked('buildingLabels'))
		return;
	const buildingLabels = TRoot.querySelectorAll('.building-labels_wrapper');
	const buildingApartmentsCount = TRoot.querySelectorAll('.building-label__apartments-count');
	const labels = [...buildingLabels,...buildingApartmentsCount];
	
	if (labels.length) {
		labels.forEach(label => {
			label.classList.remove('hidden');
			label.classList.remove('hide__label');
		});
	}

	Cluster.show();
	Cluster.update();
}

// export function buildingsLabelHideWhenAnimationStart () {
//     if (settingsData.buildingDestroyed){
//         return;
//     }
//
//     const buildingLabels = document.querySelectorAll('.building-labels_wrapper');
//
//     if (buildingLabels.length){
//         buildingLabels.forEach(label =>{
//             label.style.display = 'none';
//         });
//     }
// }

export function buildingsLabelHideWhenAnimationStart() {
	const buildingLabels = document.querySelectorAll('.building-labels_wrapper');

	if (buildingLabels.length) {
		buildingLabels.forEach(label => {
			label.classList.add('hide__label');
			// label.style.display = 'none';
		});
	}
}

// export function hoverBuildingLabel () {
//     const labelExist = threeJsVariables.scene.getObjectByName('Building hover label');
//     if (!labelExist){
//         const labelContainer = document.createElement('div');
//         //labelContainer.textContent = 'Click to enter';
//         labelContainer.classList.add('building__hover-label');
//
//         const label = new CSS2DObject(labelContainer);
//         label.name = 'Building hover label';
//         label.visible = false;
//         label.material = new THREE.MeshBasicMaterial({color: 0xffffff});
//         label.userData.zoom = isMobile ? 0.9 : 1;
//         threeJsVariables.scene.add(label);
//     } else {
//
//         const vec = new THREE.Vector3();
//         vec.set(
//           ( threeJsVariables.mouse.winX / window.innerWidth ) * 2 - 1,
//           - ( threeJsVariables.mouse.winY / window.innerHeight ) * 2 + 1,
//           0 );
//
//         vec.unproject(threeJsVariables.perspectiveCamera);
//         labelExist.position.set(vec.x,vec.y - 0.01,vec.z);
//         labelExist.visible = true;
//
//     }
// }

// export function hoverOutBuildingLabel () {
//     const labelExist = threeJsVariables.scene.getObjectByName('Building hover label');
//     if (labelExist){
//         labelExist.visible = false;
//     }
// }

export function mobileBuildingLabelsHideLogic() {
	if (config.features.poi.checkOverlapping === false || projectMode.AirMode.active) {
		return;
	}

	function getBoundingRect(label) {
		return label.element.getBoundingClientRect();
	}

	function areLabelsOverlapping(label1, label2) {
		const rect1 = getBoundingRect(label1);
		const rect2 = getBoundingRect(label2);

		return !(
			rect1.top > rect2.bottom ||
			rect1.right < rect2.left ||
			rect1.bottom < rect2.top ||
			rect1.left > rect2.right
		);
	}

	const camera = threeJsVariables.perspectiveCamera;
	for (let i = 0; i < buildingLabels.length; i++) {
		const label1 = buildingLabels[i];
		label1.element.setAttribute('mobile-hide-logic', 'show');

		for (let j = 0; j < buildingLabels.length; j++) {
			const label2 = buildingLabels[j];

			if (label1 !== label2 && areLabelsOverlapping(label1, label2)) {
				const d1 = label1.position.distanceTo(camera.position);
				const d2 = label2.position.distanceTo(camera.position);
				if (d1 < d2) {
					label2.element.setAttribute('mobile-hide-logic', 'hide');
				} else {
					label1.element.setAttribute('mobile-hide-logic', 'hide');
				}
			}
		}
	}

}

export function getBuildingLabel(color = 'white') {
	return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="3.75 2.25 16.5 20.25">
			<path d="M17.8335 4.73625C16.2758 3.13275 14.2035 2.25 12 2.25C9.7965 2.25 7.725 3.13275 6.1665 4.73625C4.608 6.33975 3.75 8.47125 3.75 10.74C3.75 13.008 4.608 15.1403 6.1665 16.7438L11.5927 22.3267C11.7052 22.443 11.8523 22.5007 12 22.5007C12.1477 22.5007 12.2955 22.443 12.408 22.3267L17.8335 16.7438C19.392 15.1395 20.25 13.008 20.25 10.74C20.25 8.472 19.392 6.33975 17.8335 4.73625Z" fill="${color}"/>
		</svg>
`
}
